import PageHeader from "../components/PageHeader";
import About from "../components/About";
import RaneSection from "../components/RaneSection";
import IRCSection from "../components/IRCSection";
import WhyChooseUs from "../components/WhyChooseUs";
import FinalCTA from "../components/FinalCTA";
import { useLang } from "../i18n/LanguageContext";

export default function AboutPage() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        overline={t("pages.aboutOverline")}
        title={<>{t("pages.aboutTitle")}</>}
        subtitle={t("pages.aboutSubtitle")}
      />
      <About />
      <RaneSection />
      <IRCSection variant="alt" />
      <WhyChooseUs />
      <FinalCTA />
    </>
  );
}
